export let hasUpdateNotifApiCalled = false

export const updateNotificationsIsRead = async (
  dispatch: any,
  setUnreadNotifIds: any,
  updateNotificationsReadStatus: any,
  unReadNotifIds: string[],
) => {
  if (hasUpdateNotifApiCalled) return
  if (unReadNotifIds.length === 0) return

  hasUpdateNotifApiCalled = true
  const unReadNotifIdsCopy = JSON.parse(JSON.stringify(unReadNotifIds))
  dispatch(setUnreadNotifIds({ ids: [], clearAll: true }))
  await dispatch(
    updateNotificationsReadStatus({
      apiPayload: { isRead: true, notificationIds: unReadNotifIdsCopy },
      showLoader: false,
    }) as any,
  )
  hasUpdateNotifApiCalled = false
}
